import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { EmailService } from './email.service';

const service = new EmailService();

export interface EmailState {}

const EmailStore: Module<EmailState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async sendEmail(context, emailData: any) {
         return await service.sendMail(emailData);
      },
   },
};

export default EmailStore;
